/* ============================================================
   crest-pdp.js - product page behaviour.

   Kept out of crest.js on purpose: crest.js drives the home page and was
   verified working in the browser. This file was written after browser access
   was lost, so it is isolated - if it misbehaves it cannot take the home page
   with it. It no-ops on any page without a PDP form.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function money(cents) {
    try {
      var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: code
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function initGallery(root) {
    var stage = root.querySelector('[data-pdp-stage-img]');
    if (!stage) return;
    root.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-pdp-thumb');
        if (!src) return;
        stage.src = src;
        root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  function initVariants(root) {
    // Liquid's {% form %} tag cannot take hyphenated attribute names, so the form
    // is matched by class with an action fallback rather than a data attribute.
    var form = root.querySelector('.pdp__form') || root.querySelector('form[action*="/cart/add"]');
    var dataEl = root.querySelector('[data-pdp-variants]');
    if (!form || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = form.querySelector('[data-pdp-variant-id]');
    var submit = form.querySelector('[data-pdp-submit]');
    var priceNow = root.querySelector('[data-pdp-price-now]');
    var priceWas = root.querySelector('[data-pdp-price-was]');
    var stock = root.querySelector('[data-pdp-stock]');
    var sku = root.querySelector('[data-pdp-sku]');
    var stage = root.querySelector('[data-pdp-stage-img]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option-index]'));

    function selected() {
      return groups.map(function (g) {
        var active = g.querySelector('.pdp__swatch.is-active');
        return active ? active.getAttribute('data-pdp-value') : null;
      });
    }

    function findVariant(values) {
      return variants.find(function (variant) {
        return values.every(function (val, i) { return variant.options[i] === val; });
      });
    }

    function apply(variant) {
      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (priceNow) priceNow.textContent = money(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = money(variant.compare_at_price);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
      if (stock) {
        stock.textContent = variant.available ? 'In stock' : 'Out of stock';
        stock.classList.toggle('pdp__stock--in', !!variant.available);
        stock.classList.toggle('pdp__stock--out', !variant.available);
      }
      if (sku) sku.textContent = variant.sku || '';
      if (stage && variant.featured_image && variant.featured_image.src) {
        stage.src = variant.featured_image.src;
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* non-fatal */ }
    }

    groups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp__swatch');
        if (!btn) return;
        group.querySelectorAll('.pdp__swatch').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        apply(findVariant(selected()));
      });
    });
  }

  function initQty(root) {
    root.querySelectorAll('.pdp__qty').forEach(function (wrap) {
      var input = wrap.querySelector('[data-pdp-qty]');
      if (!input) return;
      wrap.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-qty'), 10) || 0;
          var next = (parseInt(input.value, 10) || 1) + delta;
          input.value = next < 1 ? 1 : next;
        });
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-crest-pdp]').forEach(function (pdp) {
      if (pdp.dataset.crestReady === '1') return;
      pdp.dataset.crestReady = '1';
      initGallery(pdp);
      initVariants(pdp);
      initQty(pdp);
    });
  }

  ready(function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
